<script setup lang="ts">
import { Bar, Line } from "vue-chartjs";
import type { ChartData, ChartOptions } from "chart.js";

const props = withDefaults(defineProps<{
  data: ChartData<'bar' | 'line'>
  granularity: 'daily' | 'weekly' | 'monthly'
  chartType?: 'bar' | 'line'
  options?: Partial<ChartOptions<'bar' | 'line'>>
}>(), {
  chartType: 'bar'
});

// Build chart options: merge dashboard config + time series config + custom overrides
const chartOptions = computed(() => {
  const baseConfig = getDashboardChartConfig();
  const timeSeriesConfig = getTimeSeriesConfig(props.granularity, props.chartType);

  let merged = mergeChartOptions(baseConfig, timeSeriesConfig);

  if (props.options) {
    merged = mergeChartOptions(merged, props.options);
  }

  return merged;
});
</script>

<template>
  <div class="h-[240px]">
    <Bar v-if="chartType === 'bar'" :data="data" :options="chartOptions" />
    <Line v-else :data="data" :options="chartOptions" />
  </div>
</template>
